import { NodeFlags } from "../../Const";
import { Ease } from "../../tween/Ease";
import { Tween } from "../../tween/Tween";
export class Gear {
    constructor() {
        this.values = {};
    }
    get owner() {
        return this._owner;
    }
    set owner(value) {
        var _a, _b, _c;
        this._owner = value;
        if (value) {
            (_a = this._controller) === null || _a === void 0 ? void 0 : _a.validate();
            this.onChanged(null);
        }
        else {
            (_b = this._controller) === null || _b === void 0 ? void 0 : _b.release();
            (_c = this._tween) === null || _c === void 0 ? void 0 : _c.kill();
        }
    }
    get controller() {
        return this._controller;
    }
    set controller(value) {
        if (this._controller)
            this._controller.release();
        this._controller = value;
        if (value) {
            value.onChanged = sender => this.onChanged(sender);
            if (this._owner)
                value.validate();
        }
    }
    get propPath() {
        return this._propPath;
    }
    set propPath(value) {
        this._propPath = value;
        this._propPathArr = value ? value.split(".") : null;
        this.onChanged(null);
    }
    get tween() {
        return this._tweenCfg;
    }
    set tween(value) {
        this._tweenCfg = value;
    }
    onChanged(initiator) {
        if (this._owner && this._controller)
            this.runGear(initiator);
    }
    getValue(page) {
        let value = this.values[page];
        if (value === undefined && page != 0) {
            value = this.values[0];
            if (value != null && typeof (value) === "object" && typeof value.clone === "function")
                value = value.clone();
        }
        return value;
    }
    compareValue(value, value2) {
        if (value != null && typeof (value) === "object" && typeof value.equal === "function") {
            if (value.equal(value2))
                return true;
        }
        else if (value == value2)
            return true;
        return false;
    }
    doTween(obj, key, oldValue, newValue) {
        if (this._tween) {
            let tweener = this._tween.findTweener(null);
            if (tweener && this.compareValue(newValue, tweener.endValue.getAt(0)))
                return;
            this._tween.kill();
            this._tween.recover();
            this._tween = null;
        }
        if (this.compareValue(oldValue, newValue))
            return;
        let tc = this._tweenCfg;
        this._tween = Tween.create(obj, this._owner)
            .duration(tc.duration)
            .delay(tc.delay)
            .ease(Ease[tc.easeType])
            .go(key, oldValue, newValue)
            .then(() => {
            this._tween.recover();
            this._tween = null;
        });
        if (obj.cmdID)
            this._tween.onUpdate(() => { var _a; return (_a = this._owner._graphics) === null || _a === void 0 ? void 0 : _a.repaint(); });
    }
    runGear(initiator) {
        var _a;
        let arr = this._propPathArr;
        if (!arr)
            return;
        let obj = this._owner;
        let cnt = arr.length;
        for (let i = 0; i < cnt - 1; i++) {
            obj = obj[arr[i]];
            if (obj == null)
                return;
        }
        let key = arr[cnt - 1];
        if (this.values[0] === undefined)
            this.values[0] = obj[key];
        let newValue = this.getValue(this._controller.selectedIndex);
        if (newValue === undefined)
            return;
        let oldValue = obj[key];
        if (oldValue == null
            || !this._tweenCfg || !this._tweenCfg.enabled
            || !initiator || !initiator.changing
            || Gear.disableAllTweenEffect
            || this._owner._getBit(NodeFlags.EDITING_NODE)) {
            obj[key] = newValue;
            if (obj.cmdID)
                (_a = this._owner._graphics) === null || _a === void 0 ? void 0 : _a.repaint();
            return;
        }
        this.doTween(obj, key, oldValue, newValue);
    }
}
Gear.disableAllTweenEffect = false;
export class GearNumber extends Gear {
}
export class GearString extends Gear {
}
export class GearBool extends Gear {
}
export class GearColor extends Gear {
}
export class GearStrColor extends Gear {
    doTween(obj, key, oldValue, newValue) {
        super.doTween(obj, key, oldValue, newValue);
        this._tween && this._tween.interp(Tween.seperateChannel);
    }
}
export class GearHexColor extends Gear {
    doTween(obj, key, oldValue, newValue) {
        super.doTween(obj, key, oldValue, newValue);
        this._tween && this._tween.interp(Tween.seperateChannel, 4);
    }
}
